import { TDeliveryDocumentType } from "./types/documents";

export const deliveryTypes: TDeliveryDocumentType[] = [
    'PZ',
    'PZK',
    'PW',
]